import React from 'react';
import { useAuth } from '../context/AuthContext';
import MobileBottomSheet from './MobileBottomSheet';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiUser, FiSettings, FiLogOut } = FiIcons;

const MobileMenu = ({ isOpen, onClose }) => {
  const { user, signOut } = useAuth();

  const getInitials = (user) => {
    const name = user.display_name || user.user_metadata?.name || user.email.split('@')[0];
    return name[0].toUpperCase();
  };

  const getDisplayName = (user) => {
    return user.display_name || user.user_metadata?.name || user.email.split('@')[0];
  };

  const getAvatarUrl = (user) => {
    if (user.profile_image) {
      return user.profile_image;
    }
    if (user.avatar_url) {
      if (user.avatar_url.startsWith('http')) {
        return user.avatar_url;
      }
      const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:8000';
      return `${apiUrl}${user.avatar_url}`;
    }
    return null;
  };

  const avatarUrl = user ? getAvatarUrl(user) : null;
  const displayName = user ? getDisplayName(user) : '';
  const initials = user ? getInitials(user) : '';

  return (
    <MobileBottomSheet isOpen={isOpen} onClose={onClose}>
      <div className="space-y-4">
        {user && (
          <div className="bg-neo-yellow border-2 border-black p-4 shadow-neo-sm">
            <h3 className="text-sm font-bold uppercase mb-3 text-gray-700">Profile</h3>
            <div className="flex items-center space-x-3">
              <div className="bg-black text-white min-w-[48px] min-h-[48px] w-12 h-12 flex items-center justify-center border-2 border-white shadow-sm rounded-full overflow-hidden">
                {avatarUrl ? (
                  <img src={avatarUrl} alt="Avatar" className="w-full h-full object-cover" />
                ) : (
                  <SafeIcon icon={FiUser} size={20} />
                )}
              </div>
              <div className="overflow-hidden flex-1">
                <p className="text-sm font-black truncate text-black">
                  {displayName}
                </p>
                <p className="text-xs font-mono truncate text-gray-700">
                  {user.email}
                </p>
              </div>
            </div>
          </div>
        )}

        <div>
          <h3 className="text-sm font-bold uppercase mb-3 text-gray-500 px-1">Account</h3>
          <div className="space-y-2">
            <button
              onClick={() => {
                onClose();
                const event = new CustomEvent('openSettings');
                window.dispatchEvent(event);
              }}
              className="w-full flex items-center space-x-3 px-4 py-3 min-h-[48px] border-2 border-black bg-white hover:bg-neo-yellow transition-all shadow-neo-sm"
            >
              <SafeIcon icon={FiSettings} size={20} />
              <span className="font-bold text-sm">Settings</span>
            </button>

            <button
              onClick={() => {
                signOut();
                onClose();
              }}
              className="w-full flex items-center space-x-3 px-4 py-3 min-h-[48px] border-2 border-black bg-white hover:bg-neo-red transition-all shadow-neo-sm"
            >
              <SafeIcon icon={FiLogOut} size={20} />
              <span className="font-bold text-sm">Sign Out</span>
            </button>
          </div>
        </div>
      </div>
    </MobileBottomSheet>
  );
};

export default MobileMenu;
